import $ from 'jquery'

/**
 * Integrations - Filter integration cards by type inside a Slick slider.
 *
 * Bypasses slickFilter/slickUnfilter entirely (fragile slidesCache state).
 * On each filter: destroy Slick, append only matching items, reinit Slick.
 */
export class Integrations {
    /**
     * @param {jQuery} $container - The section DOM element
     */
    constructor($container) {
        this.$container = $container
        this.$filters   = $container.find('.integrations-filter')
        this.$slider    = $container.find('.integrations-slider')
        this.$noResults = $container.find('.integrations-no-results')
        this.classes    = { active: 'active' }

        // Rebuild slick args from the data attribute (already parsed by Slider.js,
        // controlColor already removed and applied as CSS class by that point)
        const sliderData = this.$slider.data('slider') ?? {}
        this._slickArgs = {
            lazyLoad:  'ondemand',
            infinite:  false,
            prevArrow: '<div class="slick-arrow slick-prev"><i class="icon icon-arrow-left"></i></div>',
            nextArrow: '<div class="slick-arrow slick-next"><i class="icon icon-arrow-right"></i></div>',
            responsive: [
                { breakpoint: 768,   settings: sliderData.mobile  ?? {} },
                { breakpoint: 99999, settings: sliderData.desktop ?? {} },
            ],
        }

        // Store ALL original slide elements.
        // Slick has already run so they live inside .slick-list > .slick-track,
        // but jQuery .find() still reaches them through the wrapper.
        this._$allItems = this.$slider.find('.integrations-item')

        if (this.$filters.length) {
            this.bindEvents()
        }
    }

    bindEvents() {
        this.$filters.on('click', this.handleFilterClick.bind(this))
    }

    /**
     * @param {Event} e
     */
    handleFilterClick(e) {
        const $btn   = $(e.currentTarget)
        const filter = ($btn.data('filter') ?? 'all').toString()

        this.$filters.removeClass(this.classes.active)
        $btn.addClass(this.classes.active)

        // 1. Destroy Slick: unwraps .slick-list/.slick-track, removes slick classes
        if (this.$slider.hasClass('slick-initialized')) {
            this.$slider.slick('unslick')
        }

        // 2. Detach every item so the slider container is empty
        this._$allItems.detach()

        // 3. Select matching items by reading data-types directly from the attribute
        const $matching = filter === 'all'
            ? this._$allItems
            : this._$allItems.filter((_, el) => {
                const types = $(el).attr('data-types')
                return types.includes(filter)
            })

        // 4. Re-append matching items and toggle the no-results message
        this.$slider.append($matching)
        const hasVisible = $matching.length > 0
        this.$noResults.prop('hidden', hasVisible)

        // 5. Reinitialise Slick on the filtered set
        if (hasVisible) {
            this.$slider.slick(this._slickArgs)
        }
    }
}
